
import { Component } from 'vue-property-decorator';
import { Button } from 'ant-design-vue';
// @ts-ignore
import TrackeData from '@/utils/trackData';
// import LessonDialog from '@/components-business/lesson-dialog.vue';
import ABTestWrapper from '@/components/ABTest/ABTestWrapper.vue';
import ClassList from '../../components/class-list.vue';
import ClassSelect from '../../components/class-select.vue';
import GuessWant from '../../components/guess-want.vue';
import Guide from '../../js/guide';
import PrePopover from '../../components/pre-notification-popover.vue';
// import SelectTheClass from '../../components/select-the-class.vue';
// import ClassAccurateList from '../../components/class-accurate-list.vue';

@Component({
  components: {
    AButton: Button,
    ClassList,
    ClassSelect,
    GuessWant,
    PrePopover,
    ABTestWrapper,
    // LessonDialog,
    // SelectTheClass,
    // ClassAccurateList,
  },
})
export default class Index extends Guide {
  [x: string]: any;

  private activeKey: string = 'msClass'

  accurateList: any[] = []

  private tabs: Record<string, any>[] = [{ key: 'msClass', name: '面授班级' }, { key: 'jzxClass', name: '精准学班级' }]

  get showMyClass() {
    return this.activeKey === 'msClass';
  }

  get lengthThanZero() {
    return this.accurateList.length > 0;
  }

  private changeClassList(key: string) {
    if (key === 'jzxClass') {
      this.$utils.sendAction('index', 'history', 'id-18');
    }
    this.activeKey = key;
  }

  private async getAccurateList() {
    try {
      const result: any = await this.$service.bk.getAccurateList();
      this.accurateList = result;
    } catch (error) {
      this.$message.error(error.message);
    }
  }

  // 处理下载按钮点击事件
  private handleDownload() {
    // 打开下载页面
    window.open(`https://aixuexi-test.oss-cn-beijing.aliyuncs.com/english-spokenplanet/download/download.html?t=${Date.now()}`, '_blank');
  }

  mounted() {
    // this.getAccurateList();
    // 延迟检查 this.$track 是否有值 埋点
    const checkTrack = setInterval(() => {
      if (this.$track) {
        this.$track.sendPageLog(TrackeData.PRELESSONS_PAGE_SHOW, {});
        clearInterval(checkTrack);
      }
    }, 100); // 每100毫秒检查一次
  }
}
